import { formatGradeRange } from "@nimble/ts-formatters/format-grade-range";

import { schoolGradesTestIds } from "@/lib/data-test-ids/schools.data-test-ids";
import { SchoolDetailGradesProps } from "@/lib/types/schools.types";

export default function SchoolDetailGrades({
  grades,
  schoolId,
}: SchoolDetailGradesProps) {
  return (
    <div className="flex items-center gap-2">
      <span className="text-[10px] sm:text-xs text-ink-subtle font-medium">
        Grades:
      </span>
      <div className="flex gap-1 flex-wrap">
        <span
          className="text-[10px] sm:text-xs text-ink-emphasis font-medium"
          data-testid={`${schoolGradesTestIds.SCHOOL_GRADES}-${schoolId}`}
        >
          {formatGradeRange(grades)}
        </span>
      </div>
    </div>
  );
}
